import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "../src/Home";
import TopTokens from "./Pages/TopTokens";
import TokenTransfer from "./Pages/TokenTransfer";
import Blocks from "./Pages/Blocks";
import Transactions from "./Pages/Transactions";
import TransactionDetails from "./Pages/TransactionDetail";
import BlockDetails from "./Pages/BlockDetail";
import VerfiedContracts from "./Pages/VerfiedContracts";
import RichList from "./Pages/RichList";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import { useState } from "react";
import AdressDetail from "./Pages/AdressDetail";
import TokenDetail from "./Pages/TokenDetail";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./Pages/NotFound";
function App() {
  const [theme, settheme] = useState("Darktheme");
  useState(() => {
    const savedTheme = localStorage.getItem("Theme");
    if (savedTheme) {
      settheme(savedTheme);
    }
  }, []);

  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate("/");
  };

  return (
    <div className={theme}>
      <NavBar settheme={settheme} currenttheme={theme} />
      <ToastContainer />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/TopTokens" element={<TopTokens />} />
        <Route path="/TokenTransfer" element={<TokenTransfer />} />
        <Route path="/blocks" element={<Blocks />} />
        <Route path="/tx/:var" element={<TransactionDetails />} />
        <Route path="/token/:var" element={<TokenDetail />} />
        <Route path="/block/:var" element={<BlockDetails />} />
        <Route path="/addresses/" element={<AdressDetail />} />
        <Route path="/address/:var" element={<AdressDetail />} />
        <Route path="/txs" element={<Transactions />} />
        <Route path="/VerfiedContracts" element={<VerfiedContracts />} />
        <Route path="/RichList" element={<RichList />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer settheme={settheme} currenttheme={theme} />
    </div>
  );
}

export default App;
